import { render, staticRenderFns } from "./FieldCollection.vue?vue&type=template&id=306ced17&scoped=true&"
import script from "./FieldCollection.vue?vue&type=script&lang=js&"
export * from "./FieldCollection.vue?vue&type=script&lang=js&"
import style0 from "./FieldCollection.vue?vue&type=style&index=0&id=306ced17&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ced17",
  null
  
)

export default component.exports